import React from 'react';

interface Props {
    completed: number;
}

const ProgressBar: React.FunctionComponent<Props> = ({ completed }) => {
    const containerStyles = {
        height: '6px',
        width: '100%',
        backgroundColor: '#EFF0F0',
        borderRadius: 50,
    };

    const fillerStyles = {
        height: '6px',
        width: `${completed}%`,
        backgroundColor: '#49AE9E',
        borderRadius: 'inherit',
    };

    return (
        <div style={containerStyles}>
            <div style={fillerStyles}></div>
        </div>
    );
};
export default ProgressBar;
